import { constants } from '../common/Localization';

export const customizeErrorMessage = (input: string) => {
    return customMessageList.find(element => input.toLowerCase().includes(element.keyword))?.customMessage || input;
};

const customMessageList = [{
    keyword: 'meridian',
    customMessage: constants.ERROR_CALCULATING_EC2_RECOMMENDATION,
}];
